export const CONFIG = {
  LOGO: undefined,
  SUBDOMAIN: "",
  NAME: "Playbooks",
};
